import axios from 'axios';

const API_URL = 'https://api.msreach.msdiscoveries.com';

const api = axios.create({ baseURL: API_URL });

// Add auth token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('msreach_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('msreach_token');
      localStorage.removeItem('msreach_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const adminApi = axios.create({ baseURL: API_URL });
adminApi.interceptors.request.use(config => {
  const token = localStorage.getItem('msreach_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
